"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utils_1 = require("../utils");
// Helper hook that uses a ref to store an array, and only changes the
// value when a shallow compare fails
function useMemoizedObject(obj, equal) {
    if (equal === void 0) { equal = utils_1.shallowEqual; }
    var ref = React.useRef(obj);
    if (!equal(obj, ref.current)) {
        ref.current = obj;
    }
    return ref.current;
}
exports.default = useMemoizedObject;
//# sourceMappingURL=useMemoizedObject.js.map